import React from "react";
import PropTypes from "prop-types";
import { TooltipCircle, TooltipContainer } from "./styles";
import tooltipIcon from "../../../assets/icons/shape.svg";

export default function TooltipComponent(props) {
  let mobile = window.innerWidth < 991;
  return (
    <>
      <TooltipContainer
        overlayClassName={props.overlayclassName}
        className={props.className}
        placement={props.placement ? props.placement : mobile ? "top" : "right"}
        title={
          props.isHtml ? (
            <div dangerouslySetInnerHTML={{ __html: props.text }} />
          ) : (
            props.text
          )
        }
        autoAdjustOverflow={false}
      >
        <TooltipCircle id={props.id} src={tooltipIcon} alt="balance Tooltip" />
      </TooltipContainer>
    </>
  );
}

TooltipComponent.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  isHtml: PropTypes.bool,
  overlayclassName: PropTypes.string,
  placement: PropTypes.string,
  text: PropTypes.any
};
